// @flow

import $        from 'jquery';
import { View } from '@insolus/backbone';

// - Stylesheet
require('./inscription-step-subject.less');

class InscriptionStepSubject extends View {
    get isPrerendered(): boolean { return true; }

    get events(): Object {
        return {
            'click .inscription-step-subject__item': 'selectItem'
        };
    }

    initialize() {
        this.render();
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Rendering
    // —
    // ——————————————————————————————————————————————————————

    bindElements() {
        this.$form  = this.$el.element('form');
        this.$input = this.$el.element('input');
    }

    selectItem(e: Event) {
        const $item: JQuery = $(e.currentTarget);
        const subjectId = $item.data('id');
        this.$input.val(subjectId);
        this.$form.submit();
    }
}

export default InscriptionStepSubject;



// WEBPACK FOOTER //
// ./src/views/themes/front/components/inscription-step-subject/inscription-step-subject.js